import { collection, getDocs } from 'firebase/firestore';

export const EVENTS_COLLECTION = 'events';

export const normalizeEvent = (data, id) => ({
  ...data,
  id,
  name: data.name || data.eventName || '',
  eventDate: data.eventDate || data.date || '',
  isActive: data.isActive === true,
});

export const getEventLabel = (event) => {
  if (!event?.name) return '';
  return event.eventDate ? `${event.name} (${event.eventDate})` : event.name;
};

export const getActiveEvent = (events) => (
  events.find((event) => event.isActive)
  || [...events].sort((a, b) => String(b.eventDate || '').localeCompare(String(a.eventDate || '')))[0]
  || null
);

export const getStrictActiveEvent = (events) => (
  events.find((event) => event.isActive) || null
);

export const fetchEvents = async (db) => {
  const snapshot = await getDocs(collection(db, EVENTS_COLLECTION));
  return snapshot.docs
    .map((eventDoc) => normalizeEvent(eventDoc.data(), eventDoc.id))
    .sort((a, b) => {
      if (a.isActive !== b.isActive) return a.isActive ? -1 : 1;
      return String(b.eventDate || '').localeCompare(String(a.eventDate || ''))
        || a.name.localeCompare(b.name, 'es');
    });
};

export const fetchActiveEvent = async (db) => getActiveEvent(await fetchEvents(db));

export const fetchStrictActiveEvent = async (db) => getStrictActiveEvent(await fetchEvents(db));

export const buildEventFields = (event) => ({
  eventId: event?.id || '',
  eventName: event?.name || '',
  eventDate: event?.eventDate || '',
});

export const withEventFields = (item, fallbackEvent = null) => {
  const sourceEvent = item?.eventId ? item : fallbackEvent;
  return {
    ...item,
    ...buildEventFields(sourceEvent),
  };
};

export const getItemEventKey = (item, sale = {}) => (
  item?.eventId
  || sale?.eventId
  || item?.eventName
  || sale?.eventName
  || (item?.collection === 'products' ? item?.model : '')
  || 'sin-evento'
);

export const getItemEventName = (item, sale = {}) => (
  item?.eventName
  || sale?.eventName
  || (item?.collection === 'products' ? item?.model : '')
  || 'Sin evento asignado'
);
